import {
  DATA_USER_ALERT,
  DATA_USER_RELOAD,
  DATA_USER_STORAGE_RESET,
  DATA_USER_UPDATE_WEBLITE,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
} from '@weblite/action/user'

import { serverSub } from '$func/subscription'
import { synchronizePersist } from '$func/webApis'
import { setIsForcedUpdate } from '$setup/workbox'
import { fullReload } from '$func/fullReload'

serverSub.subscribe(DATA_USER_RELOAD, fullReload)

serverSub.subscribe(
  DATA_USER_UPDATE_WEBLITE,
  ({ forced }: { forced?: boolean }) => {
    setIsForcedUpdate(forced)
  },
)

// TODO: not used
serverSub.subscribe(DATA_USER_STORAGE_RESET, synchronizePersist)

// TODO: not used
serverSub.subscribe(DATA_USER_ALERT, ({ message }: { message: string }) =>
  // eslint-disable-next-line no-alert
  alert(message),
)
